var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster-container",class:[_vm.position]},[_c('img',{staticClass:"poster-image",attrs:{"src":_vm.url,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }